module.exports = __webpack_public_path__ + "static/media/1017396.7118e888.png";